// extracted by mini-css-extract-plugin
export default {"container":"Statusbar_container__47jNJ"};